var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-format centered",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"brand-medium font-24"},[_vm._v(_vm._s(_vm.$t('subscriptions.hang-tight')))])])}
var staticRenderFns = []

export { render, staticRenderFns }